export const getHash = () => {
  return window.location.hash.replace('#', '')
}
